module.exports = __webpack_public_path__ + "static/media/report.86e42750.pdf";